import script from "./CrudPatrocionadores.vue?vue&type=script&setup=true&lang=js"
export * from "./CrudPatrocionadores.vue?vue&type=script&setup=true&lang=js"

import "./CrudPatrocionadores.vue?vue&type=style&index=0&id=e79e8e04&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e79e8e04"]])

export default __exports__